<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34">
  <g id="dashboard-icon-off" transform="translate(-120 -300)">
    <g id="Rectángulo_18" data-name="Rectángulo 18" transform="translate(120 300)" fill="#fff" stroke="#707070" stroke-width="1" opacity="0">
      <rect width="34" height="34" stroke="none"/>
      <rect x="0.5" y="0.5" width="33" height="33" fill="none"/>
    </g>
    <path id="Trazado_7325" data-name="Trazado 7325" d="M22.249,13.438a1.6,1.6,0,0,1-1.121-.464l-8.1-8.1a1.586,1.586,0,0,1,2.241-2.241l8.1,8.1a1.586,1.586,0,0,1-1.121,2.7ZM11.267,16.979,9.025,14.738,14.733,9.03l2.241,2.241Zm2.167,5.275a1.586,1.586,0,0,1-2.7,1.121l-8.1-8.1a1.586,1.586,0,0,1,2.241-2.241l8.1,8.1A1.6,1.6,0,0,1,13.433,22.253ZM6.067,23.912,2.092,19.938a1.222,1.222,0,0,1,0-1.733L2.6,17.7,8.308,23.4l-.508.508A1.257,1.257,0,0,1,6.067,23.912ZM19.933,2.1l3.975,3.975a1.226,1.226,0,0,1,0,1.733l-.508.508L17.692,2.6,18.2,2.1A1.257,1.257,0,0,1,19.933,2.1Zm5.2,6.933a2.959,2.959,0,0,0,0-4.184L23.759,3.471,24.879,2.35,23.654,1.125,22.533,2.246,21.159.871a3.031,3.031,0,0,0-4.184,0l-.511.511A3.316,3.316,0,0,0,11.8,6.1l1.7,1.7L7.8,13.512l-1.7-1.7a3.315,3.315,0,0,0-4.719,4.658l-.511.511a2.959,2.959,0,0,0,0,4.184l1.375,1.375L1.121,23.658l1.225,1.225,1.121-1.121,1.375,1.375a2.959,2.959,0,0,0,4.184,0l.511-.511A3.316,3.316,0,0,0,14.2,19.907l-1.7-1.7L18.2,12.5l1.7,1.7a3.315,3.315,0,0,0,4.719-4.658Z" transform="translate(124 303.981)" :fill="colorx"/>
  </g>
</svg>
</template>

<script>
export default {
  data: () => ({

  }),
  props: {
    colorx: {
      type: String,
      default: '#89899B'
    }
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/shared/icons/PersonalTrainerIcon.vue